import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import uuid from "uuid";

import {
  wizardAllObjectInterface,
  wizardGroupInterface,
} from "../../../../interfaces/wizardItemInterface";
// import {featureGroupInterface} from "../../../../interfaces/featureInterface";
import AdvancedQuotingListItemRemoveButton from "../advancedQuotingListItemRemoveButton";
import {FormattedMessage} from "react-intl";
// import CartItemSearchButton from "../cartItemSearchButton";
import AdvancedQuotingWizardGroupsSearch from "./advancedQuotingWizardGroupsSearch";
import {getWizardProductGroupName} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setNewActiveQuote} from "../../../../misc/quotesFunctions";
import {checkIfNeedToSetNewCategory} from "../../../../misc/categorySwitchingFunctions";
import {setActiveQuoteIndex} from "../../../../actions/roomsFunctions";
import goToMaterialPage from "../../../common/goToMaterialPage";

const AdvancedQuotingWizardGroups = (props) => {

  const {wizardGroup, currentGroups, stepIndex, wizardAllObject, activeQuoteIndex, setActiveQuoteIndex, stepDisabled} = props;
  const {quoteIndex, wizardSelectedValues} = wizardAllObject;

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    if (!cartItems.length) {
      addEmptyCartItem(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addEmptyCartItem = (keepPrevious) => {
    const currentCartItemsList = keepPrevious ? cartItems : [];
    setCartItems([...currentCartItemsList, {
      id: uuid.v4(),
      isEmpty: true,
      quantity: 0,
      partId: "custom",
    }])
  };

  const deleteEmptyCartItem = (cartItem) => {
    const index = cartItems.findIndex(cItem => cItem.id === cartItem.id);
    if (index > -1) {
      cartItems.splice(index, 1);
    }
    setCartItems([...cartItems])
  };

  const setClickedItemActiveQuoteIndex = async () => {
    if (quoteIndex !== activeQuoteIndex) {
      await setNewActiveQuote(quoteIndex);
      setActiveQuoteIndex(quoteIndex);
      checkIfNeedToSetNewCategory(quoteIndex);
    }
    return Promise.resolve()
  };

  const handleSearchButtonClick = async () => {
    await setClickedItemActiveQuoteIndex();
    goToMaterialPage("shoppingcart", false, null, "", wizardAllObject, stepIndex);
  }

  const nothingSelected = !wizardSelectedValues[stepIndex] || !wizardSelectedValues[stepIndex].wizardGroup;

  return (
    <Fragment>
      <h3 className={"scart-block__title scart-block__title--blue" + (stepDisabled ? " disabled2" : "")}>
        {wizardGroup.productCartDescription || getWizardProductGroupName(wizardGroup)}
      </h3>
      <div className={"scart-block__list" + (!cartItems.length ? " scart-block__list--hidden" : "")}>
        {cartItems.map((cartItem, cartItemIndex) => {
          return (
            <div className={"aq" + (stepDisabled ? " disabled2" : "")} key={cartItemIndex}>
              <div className="aq-item">
                <AdvancedQuotingListItemRemoveButton cartItem={cartItem}
                                                     isDisabled={stepDisabled}
                                                     deleteEmptyCartItem={deleteEmptyCartItem}
                                                     quoteIndex={quoteIndex}/>
                <div className="aq-cell aq-cell--name">
                  <div className="aq-title"><FormattedMessage id="advancedQuoting.itemTitle"/></div>
                  <div className="aq-main">
                    <AdvancedQuotingWizardGroupsSearch cartItem={cartItem} 
                                                       stepIndex={stepIndex}
                                                       isDisabled={stepDisabled}
                                                       currentGroups={currentGroups}
                                                       wizardAllObject={wizardAllObject} />
                    <button className={"aq-button aq-button--search" + (nothingSelected ? " aq-button--disabled" : "")}
                            disabled={nothingSelected} onClick={handleSearchButtonClick} />
                    <button className={"aq-button aq-button--note aq-button--disabled"} disabled={true}/>
                  </div>
                </div>
                <div className="aq-cell aq-cell--quantity"/>
                <div className="aq-cell aq-cell--total"/>
              </div>
            </div>
          )
        })}
      </div>
      {cartItems.length || stepDisabled ? null : (
        <div className="dcart-advanced__add-button">
          <button className="ui-button2 ui-button2--gray-plus" onClick={addEmptyCartItem}>
            <FormattedMessage id="advancedQuoting.addProductButton"/>
          </button>
        </div>
      )}
    </Fragment>
  )
};

AdvancedQuotingWizardGroups.propTypes = {
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface).isRequired,
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)).isRequired,
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
  // featureGroup: PropTypes.shape(featureGroupInterface).isRequired,
  stepIndex: PropTypes.number.isRequired,
  stepDisabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (store) => {
  const {activeQuoteIndex} = store.quotesState;
  return {
    activeQuoteIndex,
    // advancedCartItemsLength: ownProps.advancedCartItems.length,
    // allIds: ownProps.advancedCartItems.map((cartItem) => cartItem.id).join(),
    // allSqftIds: ownProps.advancedCartItems.map((cartItem) => cartItem.sqftId).join(),
    // fabricatorData: store.fabricatorState
  };
};

const mapDispatchToProps = {
  setActiveQuoteIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingWizardGroups)
